import React, { useState, useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';

import avatar1 from "../assets/images/avatar01.png";
import avatar2 from "../assets/images/avatar02.png";
import avatar3 from "../assets/images/avatar03.png";
import avatar4 from "../assets/images/avatar04.png";
import avatar5 from "../assets/images/avatar05.png";
import avatar6 from "../assets/images/avatar06.png";
import avatar7 from "../assets/images/avatar07.png";
import avatar8 from "../assets/images/avatar08.png";
import p_conferma from "../assets/images/p_conferma.png";
import p_annulla from "../assets/images/p_annulla.png";


const avatars = [
    { id: 1, src: avatar1, name: "avatar01" },
    { id: 2, src: avatar2, name: "avatar02" },
    { id: 3, src: avatar3, name: "avatar03" },
    { id: 4, src: avatar4, name: "avatar04" },
    { id: 5, src: avatar5, name: "avatar05" },
    { id: 6, src: avatar6, name: "avatar06" },
    { id: 7, src: avatar7, name: "avatar07" },
    { id: 8, src: avatar8, name: "avatar08" },
];


const IpadAvatar = () => {
    const [selectedAvatar, setSelectedAvatar] = useState(null);
    const navigate = useNavigate();
    const location = useLocation();
    const [userId, setUserId] = useState(null);

    // Ottieni l'ID utente dalla query string
    ///
   /* useEffect(() => {
        const queryParams = new URLSearchParams(location.search);
        const id = queryParams.get('userId');
        setUserId(id);
    }, [location.search]);*/

    // Ottieni l'ID utente dallo stato passato tramite navigate
    useEffect(() => {
        if (location.state && location.state.userId) {
            setUserId(location.state.userId);
        } else {
            // Se non trovi l'ID, reindirizza alla pagina di registrazione o mostra un errore
            navigate('/ipad/register');
        }
    }, [location.state, navigate]);


    const handleAvatarSelect = (avatar) => {
        setSelectedAvatar(avatar);
    };

    const handleSubmitAvatar = async () => {
        if (selectedAvatar && userId) {

            console.log(selectedAvatar);
            try {
                const response = await fetch(`${process.env.REACT_APP_API_BASE_URL}/api/avatar`, {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                    },
                    body: JSON.stringify({ avatar: selectedAvatar, userId }),
                });

                if (response.ok) {
                    console.log('Avatar selezionato con successo!');



                    navigate('/ipad/myprofile', { state: { avatar: selectedAvatar, userId } });
                } else {
                    console.log('Errore durante la selezione dell\'avatar');
                }
            } catch (error) {
                console.error('Errore:', error);
                //alert('Errore di connessione');
            }
        } else {
            alert('Prego selezionare un avatar!');
        }
    };

    const btnAnnulla = async (e) => {
        navigate(`/ipad/register`,  { state: { userId: userId } });
    };

    return (

        <div className="ipad_avatar flex flex-col w-full h-full  items-center justify-center relative bg-fixed">

            <div className="bg-black p-8 rounded-3xl shadow-md w-[840px] h-[526px] top-[158px] relative opacity-90">
                <div className="p-8">

                    <div className="grid grid-cols-4 gap-4">
                        {avatars.map((avatar) => (
                            <img
                                key={avatar.id}
                                src={avatar.src}
                                alt={`Avatar ${avatar.id}`}
                                className={`cursor-pointer w-[136px] h-auto rounded-full border-4 ${
                                    selectedAvatar === avatar.name ? 'border-blue-500' : 'border-transparent'
                                }`}
                                onClick={() => handleAvatarSelect(avatar.name)}
                            />
                        ))}
                    </div>
                    <div className="flex justify-center pt-10">
                       {/* <button
                            onClick={btnAnnulla}
                            className="w-auto"
                            style={{background: 'none', border: 'none'}}
                        >
                            <img
                                src={p_annulla}  // Percorso dell'immagine del pulsante
                                alt="Invia"
                                className="w-[225px] h-auto mr-10" // Imposta una larghezza personalizzata per l'immagine
                            />
                        </button>*/}
                        <button
                            onClick={handleSubmitAvatar}
                            className="w-auto"
                            style={{background: 'none', border: 'none'}}
                        >
                            <img
                                src={p_conferma}  // Percorso dell'immagine del pulsante
                                alt="Invia"
                                className="w-[225px] h-auto" // Imposta una larghezza personalizzata per l'immagine
                            />
                        </button>
                    </div>



                </div>
            </div>


        </div>
    );
};

export default IpadAvatar;
